import { AppBar, Drawer, IconButton } from 'material-ui';
import ExitIcon from 'material-ui/svg-icons/action/exit-to-app';
import CloseIcon from 'material-ui/svg-icons/navigation/close';
import * as React from 'react';
import 'react-quill/dist/quill.snow.css';
import { Link } from 'react-router-dom';
import { UserModel } from '../../../models';
import { Views } from '../../abstract';
import './CommonViewStyles.css';
interface IAbstractDashboardViewProps extends Interfaces.IViewProps {
    title: string;
    signOut: () => void
    routes?: any,
    userRole?: string
}

interface IAbstractDashboardViewState extends Interfaces.IViewState {
    drawerState: boolean;
}

class AbstractDashboardView<P, S> extends Views.View<P & IAbstractDashboardViewProps, IAbstractDashboardViewState & S> {

    constructor(props: any) {
        super(props);
        const defaultState: any = {
            drawerState: false
        }
        this.state = defaultState
    }

    public onChangeDrawerState(drawerState: boolean) {
        this.setState({ drawerState })
    }

    public renderMenu() {
        const { routes, userRole } = this.props;
        const keys = Object.keys(routes);
        const menuItems: any[] = [];
        keys.forEach(k => {
            if (k !== 'Home' && k !== 'SignIn') {
                Object.keys(routes[k]).forEach((kk, i) => {
                    const main = routes[k].Main;
                    if (kk === 'Main' && UserModel.Model.checkRoleAccess(main.accessForRoles, userRole as string)) {
                        menuItems.push(
                            <Link
                                style={{minHeight:50}}
                                key={k + i}
                                // tslint:disable-next-line:jsx-no-lambda
                                onClick={() => this.onChangeDrawerState(false)}
                                className="link" to={main.route}>
                                {main.title}
                            </Link>
                        )
                    }
                })
            }
        })
        return menuItems;
    }

    public render(): JSX.Element {
        const { drawerState } = this.state;
        const { title, children, signOut } = this.props;
        return (
            <div>
                <Drawer docked={true} open={drawerState}>
                    <div className="drawe-items-container">
                        <div className="top-bar">
                            <IconButton
                                // tslint:disable-next-line:jsx-no-lambda
                                onClick={() => this.onChangeDrawerState(false)}
                            >
                                <CloseIcon />
                            </IconButton>
                        </div>
                        {this.renderMenu()}
                    </div>
                </Drawer>
                <AppBar
                    // tslint:disable-next-line:jsx-no-lambda
                    onLeftIconButtonClick={() => this.onChangeDrawerState(true)}
                    style={{ backgroundColor: "#000" }}>
                    <nav className="nav-bar">
                        <div className="nav-bar-side">
                            <label>{title}</label>
                        </div>
                        <div className="nav-bar-side right">
                            <IconButton
                                onClick={signOut}
                            >
                                <ExitIcon color="#fff" />
                            </IconButton>
                        </div>
                    </nav>
                </AppBar>
                <div className="dashboard-container">
                    {children}
                </div>
            </div>
        );
    }
}

export default AbstractDashboardView;



// WEBPACK FOOTER //
// ./src/app/dashboard/common/CommonDashboardView.tsx